import React from 'react'
import './PasswordChanged.css'
import { ReactComponent as Close } from "../../assets/icons/x.svg";
import {ReactComponent as SUCCESS} from "../../assets/icons/SUCCES.svg"
import { useCheckoutT } from "../../i18n/checkout";

export default function PasswordChanged({backToSignIn, isLoginOpen}) {
  // English everywhere but the checkout (see i18n/checkout).
  const { t } = useCheckoutT();
  return (
    <div className="passwordChangedForm">
    <div className="passwordChangedFormHeader">
      <h2 className="passwordChangedFormTitle">{t("account.changed.title")}</h2>
      <Close className="signInFormIcon" onClick={isLoginOpen} />
    </div>
    <div className='passwordChangedFormSuccessIconWrap'>
      <SUCCESS className='passwordChangedFormSuccess' />
    </div>
    <span className="passwordChangedFormText">
      {t("account.changed.text")}
    </span>
    <button className="passwordChangedFormButton" onClick={()=>backToSignIn()}>{t("account.backToSignInButton")}</button>
  </div>
  )
}
